// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var BrowserComponents_Text = require("./BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Medium */3, /* Semibold */1);
}

var container = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
          hd: BrowserStyle.alignItems(BrowserStyle.center),
          tl: {
            hd: BrowserStyle.textAlign("left"),
            tl: /* [] */0
          }
        }));

function radio(isSelected) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.alignItems(BrowserStyle.center),
              tl: {
                hd: BrowserStyle.backgroundColor({
                      TAG: /* White */7,
                      _0: /* Light */2
                    }),
                tl: {
                  hd: BrowserStyle.border(BrowserStyle.rem(0.0625), BrowserStyle.solid, isSelected ? ({
                            TAG: /* Teal */6,
                            _0: /* Medium */2
                          }) : ({
                            TAG: /* Grey */2,
                            _0: /* Medium */2
                          })),
                  tl: {
                    hd: BrowserStyle.borderRadius(BrowserStyle.rem(1.0 / 2.0)),
                    tl: {
                      hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
                      tl: {
                        hd: BrowserStyle.height(BrowserStyle.rem(1.0)),
                        tl: {
                          hd: BrowserStyle.justifyContent(BrowserStyle.center),
                          tl: {
                            hd: BrowserStyle.width(BrowserStyle.rem(1.0)),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

var radioSelected = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* Teal */6,
            _0: /* Medium */2
          }),
      tl: {
        hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.625 / 2.0)),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.rem(0.625)),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.rem(0.625)),
            tl: /* [] */0
          }
        }
      }
    });

function arg$1(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Small */2, /* Normal */0);
}

var subtitle = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: /* [] */0
        }));

var subtitleSpacingBlock = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.rem(1.0)),
      tl: /* [] */0
    });

var Styles = {
  radioButtonSize: 1.0,
  interiorSelectedCircleSize: 0.625,
  container: container,
  radio: radio,
  radioSelected: radioSelected,
  subtitle: subtitle,
  subtitleSpacingBlock: subtitleSpacingBlock
};

function BrowserComponents_RadioButton(Props) {
  var className = Props.className;
  var isSelected = Props.isSelected;
  var onClick = Props.onClick;
  var subtitle$1 = Props.subtitle;
  var title = Props.title;
  var titleClassName = Props.titleClassName;
  var tmp = {
    children: null,
    onClick: onClick
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  var tmp$1 = {
    children: title
  };
  if (titleClassName !== undefined) {
    tmp$1.className = Caml_option.valFromOption(titleClassName);
  }
  return React.createElement(BrowserComponents_Button.Base.make, tmp, React.createElement(BrowserComponents_FlexRow.make, {
                  className: container,
                  children: null
                }, React.createElement(BrowserComponents_FlexColumn.make, {
                      className: radio(isSelected),
                      children: isSelected ? React.createElement("div", {
                              className: radioSelected
                            }) : null
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Small */3
                    }), React.createElement(BrowserComponents_Text.make, tmp$1)), Relude_Option.fold(null, (function (subtitle$2) {
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* XSmall */2
                                  }), React.createElement(BrowserComponents_FlexRow.make, {
                                    children: null
                                  }, React.createElement("div", {
                                        className: subtitleSpacingBlock
                                      }), React.createElement(BrowserComponents_Spacer.make, {
                                        size: /* Small */3
                                      }), React.createElement(BrowserComponents_Text.make, {
                                        className: subtitle,
                                        children: subtitle$2
                                      })));
                  }), subtitle$1));
}

var make = BrowserComponents_RadioButton;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
